<template>
    <div class="admin-page-content-in admin-page-jokes-members">
        <div class="container">
            <div class="page-title">
                <h1>Список участников</h1>
                <div class="user-name-title">
                    <span>Вы авторизованы как:</span>
                    <strong>{{adminData.user.email}}</strong>
                </div>
            </div>
            <div class="jokes-content-container">
                <div class="page-navigation">
                    <ul>
                        <li v-for="item in weekDBarr" :class="{'active' : item.week_ID == current_week}">
                            <button class="btn-week" @click="getDataByWeek(item.week_ID)"><span>{{ item.name }}</span></button>
                        </li>
                    </ul>
                </div>
                <div class="date-info">
                    <strong>с<span> {{ counteDateFrom }}</span> по <span>{{ counteDateTo }}</span></strong>
                </div>
                <div class="generate-excel">
                    <button class="btn-ex" @click="generateExcel" :class="{'active' : joinUsersList.length > 0}"><span>Сгенерировать excel файл</span></button>
                </div>
                <div class="jokes-stat">
                    <ul>
                        <li>
                            <span>Кол-во зарегистрированных кодов:</span>
                            <strong>{{ codesPerWeekCount }}</strong>
                        </li>
                        <li v-if="current_week == 5">
                            <span>Кол-во кодов (корректировка):</span>
                            <strong>{{ codesPerWeekCount_coorect }}</strong>
                        </li>
                        <li>
                            <span>Кол-во пользователей:</span>
                            <strong>{{ usersPerWeekCount }}</strong>
                        </li>
                    </ul>
                </div>
                <div class="serchfield">
                    <h2>
                        Поиск по списку
                        <button class="reset-btn" @click="resetSearch"><span>Сбросить поиск</span></button>
                    </h2>
                    
                    <div class="type-search">
                        <h3>Выберите тип поиска:</h3>
                        <ul>
                            <li :class="{'active' : serchParam == 'sername'}"><button @click="serchParam = 'sername', searchDesc = ''">Фамилия</button></li>
                            <li :class="{'active' : serchParam == 'phone'}"><button @click="serchParam = 'phone', searchDesc = ''">Телефон</button></li>
                            <li :class="{'active' : serchParam == 'city'}"><button @click="serchParam = 'city', searchDesc = ''">Город</button></li>
                            <li :class="{'active' : serchParam == 'email'}"><button @click="serchParam = 'email', searchDesc = ''">Email</button></li>
                            <li :class="{'active' : serchParam == 'date'}"><button @click="serchParam = 'date', searchDesc = ''">Дата активации</button></li>
                            <li :class="{'active' : serchParam == 'code'}"><button @click="serchParam = 'code', searchDesc = ''">Промокод</button></li>
                            <!-- <li :class="{'active' : serchParam == 'status'}"><button @click="serchParam = 'status', searchDesc = ''">Статус</button></li> -->
                        </ul>
                    </div>
                    <div class="search-form">
                        <form @submit.prevent="initSearch">
                            <div class="form-group">
                                <input type="text" name="search" v-model="searchDesc" placeholder="Поиск" class="form-control">
                            </div>
                            <div class="btn-send">
                                <button class="btn btn-submit btn-success" type="button" @click="initSearch">
                                    <span>Найти</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="members-table">
                    <div class="table-head">
                        <ul>
                            <li>Ф.И.О.</li>
                            <li>Телефон</li>
                            <li>Город</li>
                            <li>Email</li>
                            <li>Дата активации промокода</li>
                            <li>Промокод</li>
                            <li>Статус</li>
                        </ul>
                    </div>
                    <div class="talbe-info" v-if="joinUsersList.length > 0">
                        <div class="info-item" v-for="(item, index) in joinUsersList" :key="item.code">
                            <ul>
                                <li><span v-if="item.user != []"> {{ item.user.sername }} {{ firstLetter(item.user.name) }}. {{ firstLetter(item.user.familyName) }}.</span></li>
                                <li><span v-if="item.user != []">{{ item.user.phone }}</span></li>
                                <li><span v-if="item.user != []">{{ item.user.city }}</span></li>
                                <li><span v-if="item.user != []">{{ item.user.email }}</span></li>
                                <li><span v-if="item.user != []">{{ item.activate_date }}</span></li>
                                <li><span v-if="item.user != []">{{ item.code }}</span></li>
                                <li><span v-if="item.user != []">{{ item.win_status ? 'Победитель' : '...' }}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as XLSX from 'xlsx';
    import { getCountFromServer, collection, query, doc, where, setDoc, getDoc, getDocs, updateDoc, arrayUnion } from "firebase/firestore"; 
    const moment = require('moment')
    export default {
        name: 'admin--page-members',
        components: {
            // svgIcon,
        },
        data () {
            return {
                codesOrderedArr: [],
                usersOrderArr: [],
                codesPerWeekCount: 0,
                codesPerWeekCount_coorect: 0,
                usersPerWeekCount: 0,
                usersCountMin: 21,
                draftWinnerDesck: null,
                hideOtherWeeksContent: false,

                serchParam: 'code',
                searchDesc: '',
                joinUsersListDefault: [],
                joinUsersList: [],
                counteDateFrom: '',
                counteDateTo: '',
                startDate: '2024-04-01', // Начальная дата в формате YYYY-MM-DD
                endDate: '2024-04-30', // Конечная дата в формате YYYY-MM-DD
                current_week: 1,
                current_week_index: 0,
                weekDBarr: [],
            }
        },
        computed: mapGetters({
            adminData: 'loadAdminDataStore',
        }),
        methods: {
            getDataByWeek(week) {
                this.joinUsersList = [];
                this.current_week = week;
                this.current_week_index = this.current_week - 1;
                // if (this.weekDBarr[this.current_week_index].completed) {
                //     if (this.weekDBarr[this.current_week_index].winners_result != undefined) {
                //         this.draftWinnerDesck = this.weekDBarr[this.current_week_index].winners_result;
                //     }
                // } else {
                //     this.draftWinnerDesck = null;
                // }
                // console.log(this.weekDBarr[this.current_week_index].winners_result, 'WINNERS DESC RESULT')
                if (this.current_week != 5) {
                    this.getDateRange();
                } else {
                    this.counteDateFrom = moment(this.startDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                    this.counteDateTo = moment(this.endDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                    this.getDataByOrder(this.startDate, this.endDate);
                }
            },
            async getWeeksFromDB() {
                const weeks = [];
                const querySnapshot = await getDocs(collection(this.$db, "jokes"));
                querySnapshot.forEach((doc) => {
                    weeks.push(doc.data());
                });
                weeks.sort((a, b) => a.week_ID - b.week_ID);
                this.weekDBarr = weeks;
                this.current_week = this.getCurrentWeek(this.startDate);
                this.getDataByWeek(this.current_week);
                // if (this.current_week < 5) {
                // } else {
                    // this.getMainEventData(this.current_week);
                // }
                // console.log(this.weekDBarr)
            },
            getCurrentWeek(startDate) {
                const currentDate = new Date(); // Получить текущую дату
                const startDateObject = new Date(startDate); // Преобразовать начальную дату в объект Date
                const difference = currentDate - startDateObject; // Разница в миллисекундах между текущей датой и начальной датой
                const weeksDifference = Math.floor(difference / (1000 * 60 * 60 * 24 * 7)); // Количество недель между датами
                if (weeksDifference + 1 > 5) {
                    return 5
                } else if (weeksDifference + 1 < 0 || weeksDifference + 1 == 0 || weeksDifference + 1 > 0 && weeksDifference + 1 < 1) {
                    return 1
                } else {
                    return weeksDifference + 1; // +1, так как первая неделя будет нумероваться как 1, а не 0
                }
            },
            getDateRange() {
                // Задаем входные параметры
                const startDate = this.startDate;
                const selectedWeek = this.current_week; // Выбранная неделя
                const daysInWeek = 7; // Количество дней в неделе
                // Получаем массив transferred_from текущей недели
                const transferredFromIds = this.weekDBarr[this.current_week_index].transferred_from || [];
                // Вычисляем начальную дату выбранной недели
                let startOfWeek = moment(startDate).add((selectedWeek - 1) * daysInWeek, 'days');
                // Если массив transferredFromIds не пустой, находим минимальный ID и используем его для вычисления начальной даты
                if (transferredFromIds.length > 0) {
                    const minTransferredFromId = Math.min(...transferredFromIds);
                    startOfWeek = moment(startDate).add((minTransferredFromId - 1) * daysInWeek, 'days');
                }
                // Коррекция конечной даты в зависимости от количества объектов в массиве transferredFromIds
                let endOfWeek = moment(startOfWeek).add(daysInWeek - 1, 'days'); // Добавляем 6 дней для получения конечной даты недели
                transferredFromIds.forEach(() => {
                    endOfWeek = moment(endOfWeek).add(daysInWeek, 'days'); // Добавляем кол-во дней, равное длине массива transferredFromIds
                });
                // Если выбрана 4 неделя и нет переданных предыдущих недель (transferredFromIds), добавляем 2 дня к конечной дате
                if (selectedWeek === 4) {
                    endOfWeek = moment(endOfWeek).add(2, 'days');
                }
                // Форматируем даты в нужном формате
                const formattedStartDate = startOfWeek.format('YYYY-MM-DD');
                const formattedEndDate = endOfWeek.format('YYYY-MM-DD');
                // Выводим результаты
                this.counteDateFrom = moment(formattedStartDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                this.counteDateTo = moment(formattedEndDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                // console.log(formattedStartDate, formattedEndDate)
                this.getDataByOrder(formattedStartDate, formattedEndDate);
            },
            async getDataByOrder(fromDate, toDate) {
                // console.log(fromDate)
                // console.log(toDate)
                var codesArr = [];
                const codesQ = query(
                    collection(this.$db, "codes"), 
                    where("activate", "==", true),
                    // where("win_status", "==", false),
                    where("activate_date", ">=", fromDate),
                    where("activate_date", "<=", toDate),
                );
                // Build Data Array
                const snapshotCodesQuery = await getDocs(codesQ);
                snapshotCodesQuery.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    codesArr.push(doc.data());
                });
                this.codesOrderedArr = codesArr;
                // console.log(this.codesOrderedArr, fromDate, toDate);
                this.getUsersCounter();
                // Counter's
                const snapshotCodesCount = await getCountFromServer(codesQ);
                this.codesPerWeekCount = snapshotCodesCount.data().count;
                // console.log(codesArr, 'Массив кодов после фильтрации')
                if (this.current_week == 5) {
                    this.getCodesCount_correct(fromDate, toDate);
                }
            },
            async getCodesCount_correct(fromDate, toDate) {
                const codesQ = query(
                    collection(this.$db, "codes"), 
                    where("activate", "==", true),
                    where("win_status", "==", false),
                    where("activate_date", ">=", fromDate),
                    where("activate_date", "<=", toDate),
                );
                const snapshotCodesCount = await getCountFromServer(codesQ);
                this.codesPerWeekCount_coorect = snapshotCodesCount.data().count;
            },
            async getUsersCounter() {
                // console.log(this.codesOrderedArr, 'Массив кодов - функция юсера')
                const codesArr = this.codesOrderedArr;
                const usersIDsArr = [];
                const usersData = [];
                codesArr.forEach((code) => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    usersIDsArr.push(code.userID);
                });
                // console.log(usersIDsArr);
                const uniqueArr = this.uniqueById(usersIDsArr);
                // console.log(uniqueArr);
                this.usersPerWeekCount = uniqueArr.length;
                // this.usersPerWeekCount = 14
                const batchSize = 30; // Maximum number of values per batch
                const totalUsers = uniqueArr.length;
                for (let i = 0; i < totalUsers; i += batchSize) {
                    const batch = uniqueArr.slice(i, i + batchSize);
                    console.log(batch, 'BATCH')
                    const usersQ = query(
                        collection(this.$db, "users"), 
                        where("user.ID", "in", batch)
                    );

                    const snapshotUsersQuery = await getDocs(usersQ);
                    snapshotUsersQuery.forEach((doc) => {
                        usersData.push(doc.data());
                    });
                }

                this.usersOrderArr = usersData;
                this.joinCodes_Users_arr(this.codesOrderedArr, this.usersOrderArr);
                // console.log(usersData, 'USERS DATA');
                // const usersQ = query(
                //     collection(this.$db, "users"), 
                //     where("user.ID", "in", uniqueArr)
                // );
                // const snapshotUsersQuery = await getDocs(usersQ);
                // snapshotUsersQuery.forEach((doc) => {
                //     // doc.data() is never undefined for query doc snapshots
                //     // console.log(doc.id, " => ", doc.data());
                //     usersData.push(doc.data());
                // });
                // this.usersOrderArr = usersData;
                // console.log(usersData, 'USERS  DATA')
            },
            joinCodes_Users_arr(codes, users) {
                console.log(codes)
                console.log(users)
                // Создаем объект для быстрого доступа к пользователям по их ID
                const usersMap = {};
                users.forEach(user => {
                    usersMap[user.user.ID] = user.user;
                });

                console.log(usersMap)

                // Объединяем коды с информацией о пользователях
                const combinedArray = codes.map(code => {
                    const user = usersMap[code.userID];
                    return {
                        ...code,
                        user: user || [] // Если пользователь не найден, устанавливаем null
                    };
                });

                this.joinUsersList = combinedArray;
                this.joinUsersListDefault = combinedArray;

                console.log(combinedArray, 'ФИНАЛЬНЫЙ МАССИВ');
            },
            initSearch() {
                console.log('ПОИСК')
                const codesArr = this.joinUsersListDefault;
                if (this.searchDesc !== '') {
                    let filteredCodes;
                    switch (this.serchParam) {
                        case 'sername':
                        case 'phone':
                        case 'city':
                        case 'email':
                            filteredCodes = codesArr.filter(code => {
                                return code.user &&
                                    typeof code.user === 'object' &&
                                    Object.keys(code.user).length > 0 &&
                                    code.user[this.serchParam] &&
                                    code.user[this.serchParam].includes(this.searchDesc);
                            });
                            break;
                        case 'date':
                            filteredCodes = codesArr.filter(code => {
                                return code.activate_date.includes(this.searchDesc);
                            });
                            break;
                        case 'code':
                            filteredCodes = codesArr.filter(code => {
                                return code.code.includes(this.searchDesc);
                            });
                            break;
                        default:
                            break;
                    }

                    if (filteredCodes) {
                        this.joinUsersList = filteredCodes;
                    } else {
                        alert('Некорректный параметр поиска!');
                    }
                } else {
                    alert('Поле поиска пустое!')
                }
            },
            resetSearch() {
                this.searchDesc = '';
                this.joinUsersList = this.joinUsersListDefault;
            },
            // Функции обработчики, коррекция данных......................................................................................................
            getCurrentWeekID(curWeek) {
                if (curWeek >= 1 && curWeek <= 5) {
                    switch (curWeek) {
                        case 1:
                            return "week_one";
                        case 2:
                            return "week_two";
                        case 3:
                            return "week_three";
                        case 4:
                            return "week_four";
                        case 5:
                            return "week_five";
                    }
                } else {
                    return "Unknown week";
                }
            },
            uniqueById(array) {
                const uniqueIds = new Set();
                return array.filter(item => {
                    if (uniqueIds.has(item)) {
                        return false;
                    }
                    uniqueIds.add(item);
                    return true;
                });
            },
            firstLetter(text) {
                // Проверяем, что имя задано и не является пустой строкой
                if (text && text.length > 0) {
                    // Возвращаем первый символ имени
                    // console.log(text.charAt(0))
                    return text.charAt(0);
                } else {
                    return ''; // Если имя не задано, возвращаем пустую строку
                }
            },
            generateExcel() {
                console.log('generatex EXCEL')
                console.log(this.joinUsersList)
                const usersList = this.joinUsersList;
                const ws_data = [
                    // Добавляем пустую строку для заголовка
                    ['Список участников с ' + this.counteDateFrom + ' по ' + this.counteDateTo],
                    // Добавляем пустую строку для отступа между заголовком и заголовками столбцов
                    [],
                    // Заголовки столбцов
                    ['Code', 'Дата активации', 'Статус выигрыша', 'user ID', 'Имя', 'Фамилия', 'Отчество', 'Email', 'Телефон', 'Город']
                ];
                usersList.forEach(user => {
                    ws_data.push([
                        user.code,
                        user.activate_date,
                        !user.win_status ? '...' : 'Победитель',
                        user.user.ID,
                        user.user.name,
                        user.user.sername,
                        user.user.familyName,
                        user.user.email,
                        user.user.phone,
                        user.user.city,
                    ]);
                });

                const worksheet = XLSX.utils.aoa_to_sheet(ws_data);
                worksheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 9}}];
                // Регулировка ширины столбцов
                worksheet['!cols'] = [
                    {wch: 15}, 
                    {wch: 15},  
                    {wch: 18},  
                    {wch: 40},
                    {wch: 20},
                    {wch: 20},
                    {wch: 20},
                    {wch: 40},
                    {wch: 20},
                    {wch: 15}
                ];

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');

                XLSX.writeFile(workbook, 'members_list_jokes_week_' + this.current_week +'.xlsx');

                // const worksheet = XLSX.utils.aoa_to_sheet(ws_data);
                // const workbook = XLSX.utils.book_new();
                // XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');

                // XLSX.writeFile(workbook, 'users.xlsx');
            },  
        },
        // beforeRouteEnter (to, from, next) {
        //     const adminLocalState = localStorage.getItem('adminArrData');
        //     if (adminLocalState == null) {
        //         next('/admin/auth')
        //     } else {
        //         next();
        //     }
        // },
        beforeCreate() {
            document.body.dataset.page = 'admin-page-mailing';
        },
        created () {
            this.getWeeksFromDB();
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/admin/admin-page.scss';        
    @import '@/styles/components/admin/admin-jokes-members.scss';
</style>